import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { styled } from "@mui/material/styles";
import {
  Box
} from "@biome-design-system/ui/Box";
import { Header } from "./Header.js";
import { Navigation } from "./Navigation.js";
import { Progress } from "./Progress.js";
import { Disclaimer } from "./Disclaimer.js";
import { FilterWizardQuestionStep } from "./FilterWizardQuestionStep.js";
import { useFilterWizardContext } from "./FilterWizardContext.js";
import { getShowComponent } from "./utils.js";
const Wizard = styled(Box, {
  name: "MuiFilterWizard",
  slot: "root"
})(() => ({}));
const FilterWizardInner = ({
  children,
  disclaimer,
  header,
  hideSkip = false,
  labels,
  navigation,
  showDisclaimerOnFirstStepOnly = false,
  showHeaderOnFirstStepOnly = false,
  showSkipOnFirstStepOnly = false,
  ...restProps
}, ref) => {
  const { currentStep } = useFilterWizardContext();
  const showHeader = getShowComponent(
    Boolean(header),
    showHeaderOnFirstStepOnly,
    currentStep
  );
  const showDisclaimer = getShowComponent(
    Boolean(disclaimer),
    showDisclaimerOnFirstStepOnly,
    currentStep
  );
  return /* @__PURE__ */ jsxs(
    Wizard,
    {
      ...restProps,
      ref,
      children: [
        /* @__PURE__ */ jsx(Progress, { label: labels?.progress }),
        Boolean(showHeader) && /* @__PURE__ */ jsx(Header, { header }),
        children ?? /* @__PURE__ */ jsx(FilterWizardQuestionStep, { labels }),
        navigation !== false && /* @__PURE__ */ jsx(
          Navigation,
          {
            hideSkip,
            labels,
            navigation,
            showSkipOnFirstStepOnly
          }
        ),
        Boolean(showDisclaimer) && /* @__PURE__ */ jsx(Disclaimer, { disclaimer })
      ]
    }
  );
};
const FilterWizard = forwardRef(
  FilterWizardInner
);
export {
  FilterWizard
};
